export var toFlexAlignment = function toFlexAlignment(propValue) {
  var trimmedValue = propValue.trim();

  if (trimmedValue === 'start' || trimmedValue === 'end') {
    return "flex-".concat(trimmedValue);
  }

  return trimmedValue;
};
export var toFlexItemSizeValues = function toFlexItemSizeValues(sizeValue) {
  return {
    flexBasis: sizeValue
  };
};